import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';
import { ApAgingCommand, ApAgingExportCommand, ApAgingProviderGroup, ApAgingReport } from '../models/ap-aging/ap-aging';

@Injectable({ providedIn: 'root' })
export class ApAgingProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/ap/documents';

  /**
   * The weekly payment projection. Company scope is resolved API-side from the selected site, so it is
   * deliberately not a parameter here.
   */
  public getAging(command: ApAgingCommand): Observable<ApiResponse<ApAgingReport>> {
    return this.httpClient.post<ApiResponse<ApAgingReport>>(`${this.baseUrl}/aging`, command);
  }

  /**
   * The documents behind one provider's row. Separate from the summary so opening a provider reads a
   * provider-sized slice, rather than every open document arriving up front for a drill-down the user may
   * never perform.
   */
  public getProviderDocuments(command: ApAgingCommand): Observable<ApiResponse<ApAgingProviderGroup>> {
    return this.httpClient.post<ApiResponse<ApAgingProviderGroup>>(`${this.baseUrl}/aging/provider-documents`, command);
  }

  /**
   * The report as a workbook — by provider or by document, one endpoint for both, since the two views are
   * the same grid with different rows written out of it.
   *
   * Returns the file itself rather than an ApiResponse envelope, matching the other workbook endpoints.
   */
  public exportAging(command: ApAgingExportCommand): Observable<Blob> {
    return this.httpClient.post(`${this.baseUrl}/aging/export`, command, { responseType: 'blob' });
  }
}
